import { createContext } from "react";

import { env } from "@/lib/env";

/** Where the admin calls the services (through the gateway) and with which `fetch`. */
export interface ApiConfig {
  /** Gateway root without the version, e.g. `/api` — clients call `/v1/...` below it. */
  baseUrl: string;
  /** Tests inject a fake (MSW-style router); the browser uses the global fetch. */
  fetch?: typeof fetch;
}

/** `/api/v1` (VITE_API_BASE_URL) → `/api`. */
export function apiRoot(apiBaseUrl: string): string {
  return apiBaseUrl.replace(/\/+$/, "").replace(/\/v1$/, "");
}

export const defaultApiConfig: ApiConfig = { baseUrl: apiRoot(env.VITE_API_BASE_URL) };

export const ApiConfigContext = createContext<ApiConfig>(defaultApiConfig);
